const organizationsService = {
  async getOrganizations() {
    try {
      const { data: organizations } = await axios.get("organization/orgs", {
        params: { hasRpActive: true }
      });

      return organizations;
    } catch (error) {
      throw error;
    }
  }
};

module.exports = organizationsService;
